import React, { useState } from 'react'
import PropTypes from 'prop-types'

export const ExpandableContext = React.createContext({})

export const ExpandableBlocksContainer = ({ children, expandedId, defaultExpandedId, onExpand, nested }) => {
	const [expandedIdLocal, setExpandedId] = useState(defaultExpandedId)
	const handleExpand = (id) => {
		setExpandedId(id)
		if(typeof onExpand === 'function') {
			onExpand(id)
		}
	}
	return(
		<ExpandableContext.Provider value={{
			expandedId: expandedId || expandedIdLocal,
			setExpandedId: handleExpand,
			nested
		}}>
			{children}
		</ExpandableContext.Provider>
	)
}

ExpandableBlocksContainer.propTypes = {
	expandedId: PropTypes.string,
	defaultExpandedId: PropTypes.string,
	onExpand: PropTypes.func
}

export default ExpandableBlocksContainer
